export function sortStringsByLengthCompare(stringA: string, stringB: string): number {
  return stringB.length - stringA.length
}

export function capitalize(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
